import React, { useState, useRef, useEffect } from "react"
import { ListElementAnimated } from '../listElementAnimated/ListElementAnimated.jsx'
import './droplist.css'
import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const DropList = () => {
  const linkSet = [
    {
      setName: 'Live Models',
      linkData: [
        {link: "../swmmVision/dstore-imperv/", text: 'Web integration'},
        {link: "../swmmVision/runoff/", text: 'User friendly UIs for public-facing pages'},
        {link: "../swmmReact/multi-perspective/", text: 'Multi-perspective presentation'},
        {link: "../swmmNode/spatiallyDistributedRainfall/", text: 'GeoSpatial Rainfall Modeling'},
        {link: "../swmmNode/subareaRouting/", text: 'Subarea UI Controls'},
        {link: "../swmmNode/JunctionInvertElevation/", text: 'Junction Inverts'},
        {link: "../swmmReact/LiveModelRainFlow/", text: 'Live Model RainFlow Charts'}
      ],
    }
  ]

  // Array to hold refs and inView states
  const categoryRefs = []

  // Loop to create refs and inView states
  for (let i = 0; i < linkSet.length; i++) {
    const [ref, inView] = useInView({
      triggerOnce: false,
      rootMargin: "100px 0px 200px 0px",
    });

    // Push refs and inView states to the array
    categoryRefs.push({ ref, inView })
  }

  const [expandedArray, setExpandedArray] = useState(Array.from({length: linkSet.length}).map(()=>true))

  const handleExpandedMenu = (i) => {
    setExpandedArray(prevState => {
      const newState = [...prevState]
      newState[i] = !newState[i]
      return newState
    })
  }

  return (
    <>
      <ul>
        {
          linkSet.map((v, i)=>(
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1, transition: {duration: 1} }}
            exit={{ opacity: 0, transition: {duration: 0} }}
          >
            <div onClick={()=>handleExpandedMenu([i])} className='listbox'>
            <h3 >{v.setName}</h3>
            <motion.ul
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: expandedArray[i] ? 'auto' : 0, opacity: expandedArray[i] ? 1 : 0 }}
              transition={{ duration: 0.3 }}
              style={{ overflow: 'hidden' }}
            >
              {
                v.linkData.map((vv, ii)=>(
                  <motion.div
                    key={vv+ii}
                    initial={{ x: 300 }}
                    whileInView={{ x: 0, transition: {duration: 0.25} }}
                    exit={{ x: 300, transition: {duration: 0} }}
                  >
                    <li><ListElementAnimated link={vv.link} text={vv.text} /></li>
                  </motion.div>
                ))
              }
              </motion.ul>
            </div>
          </motion.div>
          ))
        }
      </ul>
    </>
  )
}

export default DropList